import find from 'lodash/find'
import { ErrorCode, FileError } from 'react-dropzone'
import { getErrorMessageByErrorCode, CustomErrorCodes, isErrorCodeExist } from './dragNdropUtils'
import { IUploadedImageAsset } from '@api'

export const validatorTooManyFiles = (maxFilesCounts: number): FileError[] | null => {
  if (!!maxFilesCounts) {
    return null
  }

  return [
    {
      message: 'File Exceeds Limits',
      code: ErrorCode.TooManyFiles,
    },
  ]
}

export const validatorExistingFile = (
  file: File,
  uploadedImages: IUploadedImageAsset[]
): FileError[] | null => {
  const isFileExists = !!find(uploadedImages, { fileName: file.name.replace(' ', '_') })

  if (!isFileExists) {
    return null
  }

  return [
    {
      message: `File ${file.name} already exists`,
      code: CustomErrorCodes.AlreadyExistsFile,
    },
  ]
}

export const getDefaultFileError = (error: FileError | null): FileError | null => {
  const code = error?.code || null

  if (!isErrorCodeExist(code)) {
    return null
  }

  const message = getErrorMessageByErrorCode(code)
  return {
    message,
    code: code || '',
  }
}
